import {Observable} from 'rxjs';
import {HttpService} from './http.service';
import {JsonApiResponse} from '@tisa-group/cdk/models';

export interface CrudService<T = unknown> {
  readonly http: HttpService;
  readonly list?: (params?: any, ...args: unknown[]) => Observable<JsonApiResponse<T[]>>;
  readonly fetch?: (
    fetchIdentifier: string,
    params?: any,
    ...args: unknown[]
  ) => Observable<JsonApiResponse<T>>;
  readonly create?: (
    body: Partial<T>,
    params?: any,
    ...args: unknown[]
  ) => Observable<JsonApiResponse<T>>;
  readonly update?: (
    body: Partial<T>,
    params?: any,
    ...args: unknown[]
  ) => Observable<JsonApiResponse<T>>;
  readonly delete?: (id: string, params?: any, ...args: unknown[]) => void;
}
